import { country } from './country';

export interface MapConfig {
  defaultLatitude: number;
  defaultLongitude: number;
  defaultCountryCode: country;
  defaultMode: string;
  dotIcon: string;
  markIcon: string;
}
